import React from 'react'
import {DonateButtonCombo} from 'fepp'

export const BasicInfo = ({fundraisingEvent, sponsoringName, videoUrl}) => {
  return <div className="fundraising-events-show-basic-information container">
    <div className="row text-center">
      <div className="col-md-20 offset-md-2">
        <div className={`manager-name ${fundraisingEvent.profile_picture.fallback ? 'm-b-md' : ''}`}
          dangerouslySetInnerHTML={{ __html: I18n.t('fundraising_events.show.basic_information.subheadline', { name: sponsoringName || fundraisingEvent.contact.name }) }}/>
        {(!fundraisingEvent.profile_picture.fallback || videoUrl) && <h1 className="font-desktop-xl font-phone-md" dangerouslySetInnerHTML={{ __html: fundraisingEvent.title }}/>}
        <DonateButtonCombo fundraisingEvent={fundraisingEvent} gaAction='click donate_button__top' labelClosed />
      </div>
    </div>
  </div>
}
